import styles from "./GalleryCard.module.css"
import { useEffect, useState, useRef } from 'react';
import { Maximize2 } from 'lucide-react';
import CloseButton from "../../Button/CloseButton/CloseButton";
import { handleBackgroundScroll } from "../../../utils/backgroundScroll";
import { log } from "../../../utils/logger";
/**
* Props for the GalleryCard component.
*/ 
interface GalleryCardProps{
    imgSrc: string, // Image source URL
    className?:string // Optional additional class
    onPopup?: boolean // Optional flag - tell element if its used on popup or modal - for scroll stopping purposees
}
/**
* A card component that displays an image.
*
* @param props GalleryCard props
* @param {string} props.imgSrc - Image source URL
* @param {string} [props.className] - Optional additional class
* @param {boolean} [props.onPopup] - Optional flag - tell element if its used on popup or modal - for scroll stopping purposees
* @returns TSX.Element
*/
const GalleryCard = ({imgSrc, className, onPopup = false}:GalleryCardProps) => {
    const [expanded, setExpanded] = useState<boolean>(false) // Card expanded flag

    useEffect(()=>{
        if(expanded === false) return
        handleBackgroundScroll(expanded)
    }, [expanded])

    return(
        <>
            <div className={` ${styles.GalleryPhoto} ${className ?? ''} ${expanded ? styles.Expanded : ''} `}  style={{backgroundImage: `url(${imgSrc})`}}>
                { expanded ? (
                    <CloseButton onClick={()=> {setExpanded(!expanded); onPopup === false && handleBackgroundScroll(false)}} className={styles.Close}/>
                ):(
                    <button className={styles.ExpandButton} onClick={()=> setExpanded(!expanded)}>
                        <Maximize2 />
                    </button>
                )}
            </div>
        </>
    )
};

export default GalleryCard;